'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Editions = require('self-service-api/constants/Editions');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _EditionSelectionButtonGroup = require('pricing-pages-unified-ui/components/common/EditionSelectionButtonGroup');

var _EditionSelectionButtonGroup2 = _interopRequireDefault(_EditionSelectionButtonGroup);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _ActiveHubSelectors = require('pricing-pages-unified-ui/selectors/ActiveHubSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuiteCalcEditionSelectionContainer = function SuiteCalcEditionSelectionContainer(_ref) {
  var activeEdition = _ref.activeEdition,
      activeCurrency = _ref.activeCurrency,
      setActiveEdition = _ref.setActiveEdition,
      highestOwnedEdition = _ref.highestOwnedEdition,
      activeHub = _ref.activeHub;

  (0, _react.useEffect)(function () {
    if (highestOwnedEdition !== _Editions.FREE) {
      setActiveEdition(highestOwnedEdition); // TODO i want to relocate this setting active edition on load
    }
  }, [activeHub] // this is only needed so we set activeEdition to user's appropriate edition on page load
  );

  var handleEditionUpdated = function handleEditionUpdated(edition) {
    setActiveEdition(edition);
    (0, _getUsageTracker2.default)().track('clickMerchSelectionButton', {
      merchandise: 'suite-' + edition,
      currency: activeCurrency
    });
  };

  return _react2.default.createElement(_EditionSelectionButtonGroup2.default, {
    activeEdition: activeEdition,
    onEditionUpdated: handleEditionUpdated
  });
};

SuiteCalcEditionSelectionContainer.propTypes = {
  activeEdition: _react.PropTypes.string.isRequired,
  activeCurrency: _react.PropTypes.string.isRequired,
  activeHub: _react.PropTypes.string,
  highestOwnedEdition: _react.PropTypes.string.isRequired,
  setActiveEdition: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    activeCurrency: (0, _CurrencySelectors.activeCurrencySelector)(state),
    highestOwnedEdition: (0, _ProductOwnershipSelectors.highestOwnedEditionAcrossAllHubsSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SuiteCalcEditionSelectionContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcEditionSelectionContainer.js
// module id = 783
// module chunks = 3 4